// src/utils/num.ts

/**
 * Convert unknown value to number or null
 * IMPORTANT: Empty string ('') returns null (not 0)
 */
export function toNumOrNull(x: unknown): number | null {
  if (x === null || x === undefined) return null;
  if (x === '') return null; // ** Empty string → null
  const n = Number(x);
  return Number.isFinite(n) ? n : null;
}
